var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"id":"title-bg","fixed":""}},[_c('h1',{staticStyle:{"font-weight":"400"},attrs:{"id":"titlebar-title"}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }